export enum FluidInfoEvents {
  initialised = 'initialised',
  deposit_success = 'deposit-success',
  withdrawal_success = 'withdrawal-success',
  success_cta_click = 'success-cta-click', // This event is emitted when user clicks CTA on deposit success screen
  transaction_submitted = 'transaction-submitted',
  internal_operation_change = 'internal-operation-change',
}

export enum FluidQuickDepositInfoEvents {
  'deposit-cta-clicked' = 'deposit-cta-clicked',
  'error-cta-clicked' = 'error-cta-clicked',
}

export enum FluidCommandEvents {
  close = 'close',
  handle_transaction = 'handle-transaction',
  start_kyc_verification = 'start-kyc-verification',
}
